<ng-container *ngIf="profileLoaded; else loading">
  <div class="row">
    <div class="col-2 mb-2">
      <ng-template #initials_avartar>
        <div class="avatar bigger" (click)="showForm()">
          <div class="avatar__letters">{{ currentUser.name[0] + currentUser.surName[0] }}</div>
        </div>
      </ng-template>
      <img
        *ngIf="
          (profilePicture$ | async)?.source !=
            'data:image/png;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABLAAD/4QMvaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzE0NSA3OS4xNjM0OTksIDIwMTgvMDgvMTMtMTY6NDA6MjIgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE5IChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxNkZDMDI1N0JGNTIxMUU5OTZFODg0MTg4OEY1N0RCMCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxNkZDMDI1OEJGNTIxMUU5OTZFODg0MTg4OEY1N0RCMCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjE2RkMwMjU1QkY1MjExRTk5NkU4ODQxODg4RjU3REIwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjE2RkMwMjU2QkY1MjExRTk5NkU4ODQxODg4RjU3REIwIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+/+4AJkFkb2JlAGTAAAAAAQMAFQQDBgoNAAAGgQAACAEAAAnDAAALef/bAIQAAwICAgICAwICAwUDAwMFBQQDAwQFBgUFBQUFBggGBwcHBwYICAkKCgoJCAwMDAwMDA4ODg4OEBAQEBAQEBAQEAEDBAQGBgYMCAgMEg4MDhIUEBAQEBQREBAQEBARERAQEBAQEBEQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQ/8IAEQgAeAB4AwERAAIRAQMRAf/EAMMAAQADAAMBAAAAAAAAAAAAAAAFBgcBAwQCAQEAAAAAAAAAAAAAAAAAAAAAEAABBAECBQMFAQAAAAAAAAAFAQIDBAAVBhAgMBQWUHAREjITMyRGEQABAQQFCAoBBQEAAAAAAAABAgARIQMxoRIzBCAwQVFxgdETEGGxwSIyUiMUBVBCYnKiwhUSAQAAAAAAAAAAAAAAAAAAAHATAQABAgQEBgMBAQAAAAAAAAERACExQVFhMIGR8RAg8HGh0VBwscHh/9oADAMBAAIRAxEAAAG5AAAAAAAAAAAAAAAAAA9R7COOoAAAAAuBJkaTZTiEAAAAOTSDNgfRoxm4AAAB2F/M8ANGM5AAAAOTSTNQdhoRnIAAAALkeArhfCuEMAAAAShdSvFXL2dpSjyAAAF7OSlnnAJAu5AFXAAJQshRwAADSjNjgAFhLERYAABZDMjpABySp9AAAHQRwAAAAAAAAAAAAAAAB//aAAgBAQABBQL0SKtYnxRRFEkikiXphRLLCWdwwQYm5rXzWJ0SyFRyj5+kXd2Ingiq1Sn9gXos+/c36OP+b6V5NSC8I2Oleac2mL6W376RPMDVpTYBH/jQpe7610aY23dWAUPGNKmFu8BxyN8dvb8UyWKs9V/ONDwMhubhazJp5rD+NW/aprWMUiDS4jseYbXSze3Jad9fOLfqQpU+F5AUjIyJMJZu2/GrueNXc8au541dzxq7njV3PGruCR8gxkzkdLytKkWpq5LNXJZq5LNXJZq5LNXJZq5LJiF2w30H/9oACAECAAEFAveH/9oACAEDAAEFAveH/9oACAECAgY/AmH/2gAIAQMCBj8CYf/aAAgBAQEGPwL8J7MtS9gZ/IU1makoOoh2c+XirseROtzcrBy7YTB9CdzRlIdvb4uJl2VGhKqDsLWRGWuMtXdm0YaXC06XudHpCkwIoLIxP6hZX3HNJ2tJ/kezIj6P9ZtM9EVJAXvEFdKZaIqUXANLwaaVWU7k05s4OafDMig/u1b25ksezM8vUdXR/wBHE+GHtv1epjMHkT4ZezNeyjw+swS3yMYsKUNKqNwbkSfDJ0vpV0fF+xoot6COtud9etz4hNKTsLWJ6Cg5gY37CjzBBoA625X16YCHMNG4NzJyytWs5D5C3DSnQ3xscgJJ1+U8G58iMk/1OVKlGh71bBFkYNJg62vuzC8NOiUvlv7CzjkotwtPSNpZWIlrSAXQU/Q15Lr4NeS6+DXkuvg15Lr4NeS6+DXkuvg15Lr4NOOIWlynGGh21lqTQSSMqyJ6u1r81Nfmpr81Nfmpr81Nfmpr81NYnTipOr8F/9oACAEBAwE/IfwnPcXTrUoRbEvQrc9KXzxEZ3rlh4l2KTj2DTaDLpWJDQRes1Alq0nKRqSrORjutzhY2pLuSk0S6o+fF6JAhiJTHSx7S/Zws5o/tT2fIHhxl2x2YP74jXBa5bFIdgO8KusdeHH2aVgehz96Z3gsPe/58Bw4JNoZlywptOxsz58LmI2znnyonfuWi/K0eig7gYTobeEFhRFk4CD/AL1qGgXl5An/AGtDYTg+zg8CNuzA8o/WjEuAGPT16UgUMyenkmbzG79xrBaeL22c3qamEjYRutk7aPmJeXE1GRzinQgwDNbB9uBKKFI0ieV/lIlhLJ5ZL2GuhbrhQUbJASEZDXeK+8V94r7xX3ivvFfeK2org2AWVQa18HXC+YHDGEp8mvV/SvV/SvV/SvV/SvV/SvV/SvV/SpDJjOB94/Bf/9oACAECAwE/If3D/9oACAEDAwE/If3D/9oADAMBAAIRAxEAABCSSSSSSSSSSSSSSSSSQSSSSSSQSQSSSSQCSCSSSSCSSSSSSQSSSSSSSSCQSSSSSQQASSSSASSASSQSSSSSSSCAAACSSQCSSSCSSSSSSSSSSSSSSSSf/9oACAEBAwE/EPwiSAmBb3BBUkvQHUF+KShmPTADxJuLhUsv7XiIzZmxd7jjIegcu7koU+/AGfFQwmjCIvCaDg6LQIBZADgdUvmI7HBBQLrYKdGLbqofng6y8XSrNhCREwRoEyvQizM2l9OFDSXfaFYVq/fB5PhYnp4WFyoY2PYyuQOePFQJFZsDq0VGARZNzUS4YR8yoKAUuQCNlHhTSLNctIx1ns+CcBSg2XjEDIllLo0yCHLkvKsYu7+0GXCCLEonwLNxcaBaUQBZTuYyWWLmBRx2KBOSsUCSczoUEjJ++Wc0tZD1MG+WPm+OBpMNyml+bdszOQ3HgOiFNRu8vFS5gM5bAhA2SBYwLaNGfiRQNBgGxbySeJn+HqdyHeiEOwE/YVvoThR0G0/Qmb/wbxPlJ9PXBR2whzpiQymOfYAvM04F/ji+sKt1AUDKWoyRhPK2GFNARB/DdpBd3Ray3RSefALFixYsWLYrB8fcqOi0Vmbm2Z6fD5RRksmDUbjhKINlfmuy0dlo7LR2WjstHZaOy0M4nL2K5Ag8/wAF/9oACAECAwE/EP3D/9oACAEDAwE/EP3D/9k=';
          else initials_avartar
        "
        (click)="showForm()"
        class="avatar bigger"
        [src]="(profilePicture$ | async)?.source"
        alt="current-profile-picture"
      />
    </div>
  </div>
</ng-container>
<ng-template #loading>
  <div [abpLoading]="!profileLoaded"></div>
</ng-template>

<abp-modal [busy]="isModalBusy" [(visible)]="isModalOpen">
  <ng-template #abpHeader>
    <h5 style="color: #362cad">Change profile picture</h5>
  </ng-template>

  <ng-template #abpBody>
    <div class="row" id="UploadPPContainer">
      <div class="col">
        <div class="mb-2">
          <input
            #uploadFile
            accept="image/*"
            type="file"
            class="form-control"
            id="UploadProfilePictureInfo_Picture"
            (change)="onSelectImage($event.target.files[0])"
          />
        </div>

        <ng-container *ngIf="selectedImage">
          <div class="general-image-container">
            <img
              #selectedImgRef
              class="selected-image"
              alt="selected-image"
              [src]="selectedImage"
            />
          </div>

          <div id="CursorInfo" class="mt-2">
            Profile picture preview
          </div>

          <div class="image-process-section">
            <ul class="sample-images clearfix mt-2">
              <li class="big"><img #preview alt="selected-image-preview-big" /></li>
              <li class="medium"><img #preview alt="selected-image-preview-medium" /></li>
              <li class="small"><img #preview alt="selected-image-preview-small" /></li>
            </ul>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-template>
  <ng-template #abpFooter>
    <abp-button
      iconClass="fa fa-check"
      buttonClass="btn btn-outline-primary"
      (click)="submit()"
      buttonType="submit"
      >Save</abp-button
    >
    <button type="button" class="btn btn-secondary" (click)="hideForm();">Cancel</button>
  </ng-template>
</abp-modal>
